import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios, { AxiosHeaders, type InternalAxiosRequestConfig } from 'axios'
import { toast } from 'react-toastify'
import { QUERY_KEY_FORECAST_BY_COUNTRY_CODE } from './useApiGetForecastByCountryCode'
import { GLOBAL_ERROR } from '../../constants/translations/error'
import { useTranslation } from 'react-i18next'

interface ForecastPutActivateParams {
  countryCode: string
  isActivated: boolean
}

export const useApiPutForecastActivateButton = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: ForecastPutActivateParams) => {
      const url = `/forecast/${params.isActivated ? 'deactivate' : 'activate'}/${params.countryCode}`
      const config: InternalAxiosRequestConfig = { method: 'put', url, headers: new AxiosHeaders() }
      return axios(config)
    },
    onSuccess: () => {
      toast.info(t('pilotable.data_saved'))
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY_FORECAST_BY_COUNTRY_CODE] })
    },
    onError: () => {
      toast.error(t(GLOBAL_ERROR))
    }
  })
}
